'use client'

import { useQueryState } from 'nuqs'
import AllShippers from './components/AllShippers'
import ShippersByCategory from './components/ShippersByCategory'
import { Box } from '@chakra-ui/react'
import BrandTabs from '@/app/[locale]/(universal)/brand/_components/BrandTabs'

const Brands = ({ shipperId }: { shipperId?: string | null }) => {
  const [category] = useQueryState('category')

  if (category) {
    return <ShippersByCategory shipperId={shipperId} />
  }

  return (
    <Box mt={{ base: 6, lg: 0 }} px={{ base: 4, lg: 14 }}>
      <BrandTabs />
    </Box>
  )

  // return <AllShippers />;
}

export default Brands
